import { Fraga } from "@/types/riskbedomning";

export const byggbarhetKonstruktionFragor: Fraga[] = [
  {
    id: "fallrisker-stallningar-sammansatt",
    text: "Finns det risk för fallrisker, instabilitet i ställningar och tillfälliga konstruktioner?",
    kategori: "Byggbarhet & konstruktion",
    fas: "byggskede",
    followUpQuestions: [
      "Krävs särskild planering för att undvika att personal arbetar direkt ovanför varandra?",
      "Finns risk att säkerhetsräcken eller skyddsnät saknas eller inte är korrekt monterade där de behövs?",
      "Finns det risk att föremål faller och orsakar skador på personal nedanför?",
      "Finns risk att stegar, ställningar eller arbetsplattformar inte är korrekt dimensionerade eller tillräckligt säkrade för det arbete som utförs?",
      "Kan brist på planerad kontroll eller underhåll av temporära plattformar öka risken för olyckor eller ras?",
      "Kan brist på tydliga säkerhetsfaktorer i beräkningarna öka risken för fel i dimensionering eller konstruktion?",
      "Kan otydligt ansvar för besiktning av tillfälliga konstruktioner leda till att kontroller uteblir eller försenas?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13", "AFS 2023:9"]
  },
  {
    id: "tornkranar-lyft-sammansatt", 
    text: "Kan planerad användning av tornkranar, lyftanordningar eller tunga element innebära risker för olyckor eller skador om säkerhetsåtgärder brister?",
    kategori: "Byggbarhet & konstruktion",
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande planering eller kontroll vid placering och montering av tornkran leda till olyckor eller instabilitet?",
      "Riskerar kranförare eller signalmän att sakna nödvändig kompetens eller certifiering?",
      "Kan bristande rutiner för starka vindar eller dålig sikt vid lyft öka risken för olyckor eller tappade laster?",
      "Kan bristande samordning mellan tornkranen och andra transporter eller lyft skapa risk för kollisioner eller driftstörningar?",
      "Kan bristande planering eller övervakning leda till kollisioner mellan lyftanordningar och annan utrustning?",
      "Kan brist på lyfttillstånd eller utbildade signalmän leda till missförstånd och riskfyllda lyftmoment?",
      "Finns risk att lyftutrustningen inte är besiktigad eller inte anpassad för aktuell arbetsbelastning?",
      "Kan avsaknad av lyftplanering leda till att onödigt tunga manuella lyft utförs?",
      "Finns risk för brister i placering, montering, kompetens, sikt, vindhantering eller samordning som kan leda till lyft över personer?",
      "Kan otydliga eller saknade viktangivelser öka risken för olyckor vid lyft eller transport?",
      "Riskerar transporter att ske utan säkra leder, lämplig hiss eller tillräckliga avspärrningar?"
    ],
    afsReferences: ["AFS 2023:4", "AFS 2023:9"]
  },
  {
    id: "schakt-mark-sammansatt",
    text: "Riskerar schakt- och markarbeten att genomföras utan tillräckliga säkerhetsåtgärder?",
    kategori: "Byggbarhet & konstruktion", 
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande undersökning eller förstärkning av markens stabilitet leda till ras eller sättningar?",
      "Kan schaktens utformning eller markförhållanden leda till ras, sättningar eller inträngande vatten?",
      "Kan brist på skydd, avspärrningar eller bevakning runt schaktgropar öka risken för fallolyckor?",
      "Finns risk att markgeoteknisk utredning, bärighetskontroll, vibrationsbedömning, grundläggning, pålning eller schakt inte har riskbedömts tillräckligt?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "miljopaverkan-arbetsrotation",
    text: "Kan buller, damm eller vibrationer orsaka negativ miljöpåverkan eller behov av arbetsrotation för att skydda personalen?",
    kategori: "Byggbarhet & konstruktion",
    fas: "byggskede", 
    followUpQuestions: [
      "Riskerar buller vid arbete nära maskiner att överstiga godtagna nivåer?",
      "Behövs dammbindning eller utsug för att minimera inandning av partiklar?",
      "Finns risk att vibrationsdämpande åtgärder för handhållna verktyg och maskiner saknas eller är otillräckliga?"
    ],
    afsReferences: ["AFS 2023:10"]
  },
  {
    id: "materialhantering-stadning",
    text: "Kan felaktig hantering, oordning eller olämpliga materialupplag skapa risk för olyckor eller hinder i arbetet?",
    kategori: "Byggbarhet & konstruktion",
    fas: "byggskede",
    followUpQuestions: [
      "Finns risk att områden för materialupplag inte är tydligt markerade, vilket kan öka risken för olyckor eller hinder?",
      "Riskerar material att staplas instabilt och orsaka rasolyckor?",
      "Riskerar brandfarligt material att hanteras i strid med säkerhetsföreskrifterna?",
      "Kan bristande rutiner för hantering av farliga ämnen öka risken för spill?",
      "Riskerar arbetsområdet att sakna städplan som förebygger spill och oordning?",
      "Riskerar byggdamm eller farligt avfall att hanteras utan tillräckliga skyddsåtgärder?",
      "Riskerar hantering och sortering av farligt avfall att sakna tydlig struktur eller ansvarsfördelning?",
      "Riskerar framtida material- eller renoveringsarbeten att innebära nya, obeaktade risker?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13", "AFS 2023:10"]
  }
];